import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-loader',
  templateUrl: './program-loader.component.html',
  styleUrls: ['./program-loader.component.css']
})
export class ProgramLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
